<div class="modal-content-wrapper">
  <div class="jackpot-image" (click)="openJackpotSuccessPopup()">
    <img src="assets/images/jackpot-trigger.svg" class="jackpot-trigger-img" />
  </div>
  <ion-text>
    <h1>{{'trigger.Jackpot Triggers' | translate}}</h1>
    <p>
      {{'trigger.Get' | translate}} <span class="medium-txt">{{ jackpotTrigger?.lines }} {{'trigger.lines' |
    translate}}</span> {{'trigger.jackpot exceeds' | translate}}<span class="medium-txt">£{{ jackpotTrigger?.jackpot
  }}</span>{{'trigger.for' | translate}}<span class="medium-txt">
{{'trigger.only' | translate}} £{{ jackpotTrigger?.price }}</span>
{{'trigger.each draw' | translate}}
</p>
@if (!triggers?.length) {
  <div class="light-color extra-space no-triggers-created">
    <div class="no-trigger-txt"> {{'trigger.No triggers' | translate}}</div>
    <div class="action-ic-dc">
      <span class="plus-ic">
        <ion-icon name="add-outline"></ion-icon>
      </span>
      <span class="minus-ic">
        <ion-icon name="remove-outline"></ion-icon>
      </span>
    </div>
  </div>
}
</ion-text>
@if (triggers?.length) {
  @for (trigger of triggers; track trigger) {
    <div class="trigger-lines">
      <div class="white-trigger">
        {{ trigger.lines }} lines on £{{ trigger.jackpot_trigger }}+
        <div class="action-ic-dc">
          <span class="plus-ic">
            @if (!spinnerAnimation) {
              <ion-icon name="add-outline"></ion-icon>
            }
            @if (spinnerAnimation) {
              <ion-spinner></ion-spinner>
            }
          </span>
          <span class="minus-ic">
            @if (!spinnerForDecline) {
              <ion-icon name="remove-outline" (click)="deactivateTrigger(trigger?.id)">
              </ion-icon>
            }
            @if (spinnerForDecline) {
              <ion-spinner></ion-spinner>
            }
          </span>
        </div>
      </div>
    </div>
  }
}
<div class="bottom-action">
  <ion-button shape="round" class="purple-btn create-trigger-btn" (click)="createTrigger(); startSpinner()">
    @if (!spinnerAnimation && proceed) {
      <span> {{'trigger.Create trigger' | translate}}</span>
    }
    @if (spinnerAnimation) {
      <div class="spinners">
        <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
        </mat-progress-spinner>
      </div>
    }
    @if (!proceed) {
      <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
    }
  </ion-button>
  <a class="ion-text-center nothanks" (click)="backToProduct()">{{'trigger.Close' | translate}}</a>
</div>
</div>